export default new Map([
    ['demo', 0],
    ['deathcam', 1],
    ['puddle', 2],
    ['greenBarrel', 3],
    ['table', 4],
    ['blood', 5],
    ['flag', 6],
    ['standingLamp', 8],
    ['goldenLamp', 9],
    ['hangingSkeleton', 10],
    ['pillar', 12],
    ['bones1', 13],
    ['pots', 14],
    ['furnance', 15],
    ['greenPlant', 16],
    ['skeleton', 17],
    ['sink', 18],
    ['brownPlant', 19],
    ['urn', 20],
    ['bones2', 21],
    ['bones3', 22],
    ['table', 24],
    ['lamp', 25],
    ['morePots', 26],
    ['armor', 27],
    ['cage', 28],
    ['spears', 29],
    ['vines', 30],
    ['skeletonCage', 32],
    ['bones', 33],
    ['bed', 36],
    ['bucket', 40],
    ['bloodBones', 57],
    ['brownBarrel', 58],
    ['well', 59],
    ['emptyWell', 60],
])